import React, { useState } from "react";

import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

interface Props {
  onExportSubtitle: (format: string) => void;
  onEditSubtitle: () => void;
}

export default function VerticalDotsMenu({
  onExportSubtitle,
  onEditSubtitle,
}: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            onEditSubtitle();
            handleClose();
          }}
          sx={{ fontSize: 14, borderBottom: "1px solid #e0e0e0", pb: 1 }}
        >
          <EditIcon sx={{ mr: 1, fontSize: 18 }} />
          Edit transcript
        </MenuItem>
        <MenuItem
          onClick={() => {
            onExportSubtitle("srt");
            handleClose();
          }}
          sx={{ fontSize: 14, borderBottom: "1px solid #e0e0e0", pb: 1 }}
        >
          <FileDownloadIcon sx={{ mr: 1, fontSize: 18 }} />
          Export transcript as SRT
        </MenuItem>
        <MenuItem
          onClick={() => {
            onExportSubtitle("txt");
            handleClose();
          }}
          sx={{ fontSize: 14 }}
        >
          <FileDownloadIcon sx={{ mr: 1, fontSize: 18 }} />
          Export transcript as TXT
        </MenuItem>
      </Menu>
    </div>
  );
}
